import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import CreateExtraCost from './create'
import Table from "../../components/MUITable"
import money from '../../components/Money'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import FilterListIcon from '@mui/icons-material/FilterList'
import FilterListOffIcon from '@mui/icons-material/FilterListOff'
import DeleteIcon from '@mui/icons-material/Delete'
import IndianaScroller from 'react-indiana-drag-scroll'

const ExtraCostToolbar = (props) => {
  const { selected, add, remove, clean, edit, vendor } = props

  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected.id) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)

  const [cleanDialog, setCleanDialog] = React.useState(false)
  const confirmClean = () => clean() || setCleanDialog(false)
  const closeClean = () => setCleanDialog(false)

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Costos de extra
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
        <Dialog onClose={closeClean} open={cleanDialog}>
          <DialogTitle>Limpiar</DialogTitle>
          <Button onClick={confirmClean}>Ok</Button>
        </Dialog>
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title="Editar">
            <IconButton onClick={() => edit(selected.id)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={deleteConfirmation}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }
      
      <Tooltip title="Añadir costo extra">
        <IconButton onClick={add} disabled={!vendor}>
          <AddIcon />
          {!vendor && "Seleccione un canal de venta"}
        </IconButton>
      </Tooltip>
    </Toolbar>
  )
}

const ExtraCost = () => {
  const { vendor, } = React.useContext(AppContext)
  const SalesChannel = React.useContext(SalesChannelsContext)
  const { current } = SalesChannel
  const { extraCosts, clean, remove, detail } = SalesChannel.extraCosts
  const [selected, setSelected] = React.useState([])
  React.useEffect(() => {
    if(selected.length === 1)
      detail(extraCosts.find(c => selected.includes(c.id)))
    else
      detail(null)

  }, [selected])
  const [open, setOpen] = React.useState(false)
  const openD = (s) => {
    setOpen(true)
  }


  return (
    <IndianaScroller>
    <Stack>
      <ExtraCostToolbar vendor={vendor} selected={current} add={openD} edit={openD} remove={remove} clean={clean}/>
      <Box minWidth="80vw">
        <Table
          model={selected}
          setmodel={setSelected}
          data={extraCosts}
          columns={
            [
              {flex: 1, field: 'date', headerName: 'Fecha'},
              {flex: 1, field: 'vendor', headerName: 'Canal de venta'},
              {flex: 1, field: 'type', headerName: 'Tipo'},
              {flex: 1, field: "client", headerName: "Cliente",
                valueGetter: (value, row) => row.client && row.client.name
              },
              {flex: 4, field: 'description', headerName: 'Descripción'},
              {flex: 1, headerName: "Costo", field: "cost",
                valueGetter: (value, row) => money.format(Number(row.cost))
              },
            ]
          }
          options={{
            selection: true,
            pageSizes:[5, 10,25,50,100,250,500]
          }}
          sx={{
            '& .MuiDataGrid-cellContent': {
            overflow: 'scroll',
            textOverflow: 'unset',
            }
          }}
        />
      </Box>
      <CreateExtraCost open={open} model={current} close={() => setOpen(false)}/>
    </Stack>
    </IndianaScroller>
  )
}
export default ExtraCost